import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import * as colors from '../constants/colors'
import * as spinner from '../styles/spinner'
import * as button from '../styles/button'

import { Button } from '../components/index'
import Icon from './Icon'
import LabelWithIcon from './LabelWithIcon'

const LightIcon = styled(Icon)`
  color: ${colors.GREY_SHADE_4};
`

/** This component should be used to trigger fetching more items in a list */
const LoadMoreButton = ({ loading, error, onClick, translations }) => {
  return (
    <OutlinedLoadMoreButton loading={loading} onClick={onClick} type="button">
      {error ? (
        <LabelWithIcon icon={<LightIcon glyph="refresh" size={16} />} label={translations['errorLabel']} />
      ) : (
        translations['initialLabel']
      )}
    </OutlinedLoadMoreButton>
  )
}

const OutlinedLoadMoreButton = styled(Button)`
  text-transform: none;
  color: ${(props) => colors.primary(props)};
  background-color: ${colors.PRIMARY_WHITE};
  border-radius: 2px;
  border: 2px solid;
  border-color: ${(props) => colors.primary(props)};

  &:hover {
    background-color: ${colors.PRIMARY_WHITE};
    border-color: ${(props) => colors.primaryHover(props)};
    color: ${(props) => colors.primaryHover(props)};
  }

  ${button.Label} {
    font-weight: 500;
  }

  ${spinner.Dot} {
    background-color: ${(props) => colors.primary(props)};
  }
`

LoadMoreButton.defaultProps = {
  loading: false,
  error: false,
}

LoadMoreButton.propTypes = {
  /** controls loading mode of component */
  loading: PropTypes.bool,
  /** controls error mode of component */
  error: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    initialLabel: PropTypes.string.isRequired,
    loadingLabel: PropTypes.string,
    errorLabel: PropTypes.string.isRequired,
  }).isRequired,
}

export default LoadMoreButton
